<div class="dialog-content-wrapper">
  <mat-toolbar class="mat-accent m-0">
    <mat-toolbar-row class="flex justify-between items-center">
      <span i18n class="title dialog-title">Менеджеры</span>
      <button mat-button class="mat-icon-button" (click)="dialogRef.close(undefined)" aria-label="Close dialog">
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>

  <div mat-dialog-content class="p-0 pb-0 m-0 flex flex-col" fusePerfectScrollbar>
    <mat-form-field class="w-full mini-input no-label no-subscript py-2 px-2" appearance="outline" floatLabel="never">
      <input type="text" matInput #filter i18n-placeholder placeholder="Поиск" />
      <div matSuffix>
        <mat-icon class="secondary-text">search</mat-icon>
      </div>
    </mat-form-field>
    <mat-divider></mat-divider>
    <ng-container *ngIf="managers$ | async as data">
      <mat-table class="user-table" #table [dataSource]="data.managersDTO" matSort fusePerfectScrollbar>
        <!-- Select Column -->
        <ng-container matColumnDef="select">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell *matCellDef="let item">
            <!-- <mat-checkbox [ngModel]="item.id == selectedUserId" (change)="toggleSelection(item)"></mat-checkbox> -->

            <mat-checkbox
              (click)="$event.stopPropagation()"
              (change)="$event ? selection.toggle(item) : null"
              [checked]="selection.isSelected(item)">
            </mat-checkbox>
          </mat-cell>
        </ng-container>

        <!-- SNP Column -->
        <ng-container cdkColumnDef="snp">
          <mat-header-cell i18n *cdkHeaderCellDef>ФИО</mat-header-cell>
          <mat-cell *cdkCellDef="let item">
            <p class="text-truncate h6 p-1">
              {{ item.personSurname + ' ' + item.personName + ' ' + item.personPatronymic }}
            </p>
          </mat-cell>
        </ng-container>

        <mat-header-row *cdkHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>

        <mat-row *cdkRowDef="let item; columns: displayedColumns" class="user" (click)="selection.toggle(item)">
        </mat-row>
      </mat-table>

      <mat-paginator
        #paginator
        (page)="paginationModel.next($event); getUsers()"
        [length]="data.totalCount"
        [pageIndex]="paginationModel.value.pageIndex"
        [pageSize]="paginationModel.value.pageSize"
        [pageSizeOptions]="[5, 10, 25, 100]">
      </mat-paginator>
    </ng-container>
  </div>

  <div mat-dialog-actions class="m-0 p-4 flex justify-end items-center">
    <button i18n mat-raised-button type="button" class="mat-accent mr-4" (click)="saveAndClose()">ОК</button>
    <button i18n mat-button (click)="dialogRef.close(undefined)">ОТМЕНА</button>
  </div>
</div>
